<template>
	<v-row align="center" justify="center">
		<v-col cols="12" lg="7">
			<form @submit.prevent="uploadFile">
				<v-row>
					<v-col>
						<v-file-input type="file" accept="image/*" @change="addPhoto" />
						<v-img
							v-if="!showCroppie"
							:src="user.photoUrl"
							aspect-ratio="1"
							class="grey lighten-2 profile-photo"
							max-width="220"
							max-height="220"
						/>

						<vue-croppie
							v-if="showCroppie"
							customClass="profile-photo"
							ref="croppie"
							:enableResize="false"
							:viewport="{ width: 220, height: 220, type: 'circle' }"
						/>
					</v-col>
				</v-row>
				<v-spacer></v-spacer>
				<v-row>
					<v-col>
						<v-btn color="primary" type="submit" block :disabled="!showCroppie" :loading="form.busy">{{ $t('save') }}</v-btn>
					</v-col>
				</v-row>
			</form>
		</v-col>
		<v-snackbar v-model="form.successful" bottom color="success" left :absolute="false">
			{{ $t('messages.success.save') }}
		</v-snackbar>
	</v-row>
</template>
<script>
import Form from 'vForm'
import { mapGetters } from 'vuex'
export default {
	computed: {
		...mapGetters({
			user: 'auth/user'
		})
	},

	data() {
		return {
			showCroppie: false,
			form: new Form({
				profile_pic: null
			})
		}
	},

	methods: {
		addPhoto(e) {
			let reader = new FileReader()
			reader.onload = e => {
				this.$refs.croppie.bind({
					url: e.target.result
				})
			}
			reader.readAsDataURL(e)
			this.showCroppie = true
		},
		async uploadFile() {
			if (!this.showCroppie) return
			let options = {
				type: 'blob',
				size: { width: 600, height: 600 }
				// format: 'jpeg'
			}

			await this.$refs.croppie.result(options, output => {
				this.form.profile_pic = output
			})

			let { data } = await this.form.post('/barber/profile/photo', {
				transformRequest: [
					function(data) {
						var form_data = new FormData()
						for (var key in data) {
							form_data.append(key, data[key])
						}
						return form_data
					}
				]
			})
			this.$store.commit('auth/FETCH_USER_SUCCESS', data)
			this.showCroppie = false
		}
	}
}
</script>

<style lang="scss" scoped>
.profile-photo {
	// display: block;
	margin: auto;
	margin-bottom: 2rem;
	width: 220px;
	height: 220px;
	border-radius: 50%;
	background-size: 100%;
}
</style>
